import { queryClient } from "../../lib/queryClient";

const DISCONNECT_THRESHOLD_MS = 30_000;

type HealthListener = (unhealthy: boolean) => void;

export class HealthMonitor {
  private unhealthy = false;
  private timer: ReturnType<typeof setTimeout> | null = null;
  private listeners = new Set<HealthListener>();

  isUnhealthy(): boolean {
    return this.unhealthy;
  }

  subscribe(fn: HealthListener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  onDisconnect(): void {
    if (this.timer !== null) clearTimeout(this.timer); // guard against double-call
    this.timer = setTimeout(() => {
      this.setUnhealthy(true);
    }, DISCONNECT_THRESHOLD_MS);
  }

  onReconnect(): void {
    if (this.timer !== null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.unhealthy) {
      this.setUnhealthy(false);
      queryClient.invalidateQueries({ queryKey: ["stations"] });
    }
  }

  private setUnhealthy(value: boolean): void {
    this.unhealthy = value;
    for (const fn of this.listeners) {
      try {
        fn(value);
      } catch (err) {
        console.warn("[HealthMonitor] listener threw during health state change", { value, err });
      }
    }
  }
}

export const healthMonitor = new HealthMonitor();
